import { inject, Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { AuthService } from './auth/auth.service'

/**
 * Consente l'accesso alla pagina di creazione ente solo al SuperAmministratore. A differenza di
 * {@link SuperAdminGuard} funziona anche dopo il login "ponte" (nessun ente scelto, quindi nessun
 * utente locale): in quel caso legge il flag dalla risposta di login.
 */
@Injectable({
    providedIn: 'root',
})
export class CreaEnteGuard implements CanActivate {
    private auth = inject(AuthService)
    private router = inject(Router)

    canActivate(): boolean {
        if (this.auth.isSuperAdmin()) return true
        this.router.navigate(['/login'])
        return false
    }
}
